import { HiringCompanyJobfeedAutoSuggest } from 'app/employer/components/autoSuggest';
import withAutoSuggestFormik from './withAutoSuggestFormik';
import withInputErrorMessage from '../withInputErrorMessage';

export default withAutoSuggestFormik(withInputErrorMessage(HiringCompanyJobfeedAutoSuggest));
